import {takeEvery} from 'redux-saga/effects'

import {GET_PERMISSION} from '../../Actions/Permission/ActionTypes/ApiActionTypes'
import fetchData from '../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_PERMISSION, fetchData)
}

export default dataSaga
